/**
 * @see /client/containers/OrderSummary/index.js
 */
import React, { Fragment } from 'react';

import { array, shape, func } from 'prop-types';
import { Flex, Box } from 'grid-styled';
import FontAwesomIcon from 'react-fontawesome';
import Quantity from '../../components/Quantity';

import Items from './Items';
import { StyledCardCart } from './StyledCardCart';

/**
 * @todo when gone back by clicking this to giftcard page and again click on giftcard its not rerendering the cart
 */
function CardCart(props) {
  const { cartList, orderObj, childHandler } = props;
  return (
    <Fragment>
      <StyledCardCart>
        <Flex flexWrap="wrap" className="thead">
          <Box width={[4 / 12]} className="text-left padding-l-1">
          Item
          </Box>
          <Box width={[2 / 12]}>
          Price
          </Box>
          <Box width={[4 / 12]} >
          Quantity
          </Box>
          <Box width={[2 / 12]} className="text-right">
          Subtotal&nbsp;&nbsp;&nbsp;
          </Box>
        </Flex>
        {cartList.map((cart) => (
          <Flex flexWrap="wrap" className="td" key={cart.key}>
            <Box width={[4 / 12]}>
              <Items cart={cart} {...props} />
            </Box>
            <Box width={[2 / 12]}>
              {cart.client_id === 'payment_gateway' && cart.discountPersent > 0 ? (
                <b>{cart.itemPriceAfterDisc}<br /><del>{cart.itemPrice}</del></b>
              ) : (<b>Rs. {cart.itemPrice}<br /></b>)}
            </Box>
            <Box width={[4 / 12]}>
              <Quantity quantity={cart.quantity} {...props} cart={cart} />
              <span className="pointer">
                <FontAwesomIcon
                  name="trash"
                  title="Delete"
                  role="presentation"
                  data-variationid={cart.product_variation_id}
                  onClick={(e) => childHandler('delete', e.target.getAttribute('data-variationid'), cart.title)}
                />
              </span>
            </Box>
            <Box width={[2 / 12]} className="text-right">
              {cart.client_id === 'payment_gateway' && cart.discountPersent > 0 ? (
                <b>{cart.itemSubTotalAfterDisc}&nbsp;&nbsp;&nbsp;<br /><del>{cart.itemSubTotal}</del></b>
              ) : (<b>Rs. {cart.itemSubTotal}&nbsp;&nbsp;&nbsp;<br /></b>)}
            </Box>
          </Flex>
        ))}
        <Flex flexWrap="wrap" className="thead">
          <Box width={[6 / 12]} className="text-right">
          &nbsp;
          </Box>
          <Box width={[6 / 12]} className="text-right">
            <span className="total">Total:<b>Rs. {orderObj.orderSummeryAmount}&nbsp;&nbsp;&nbsp;</b></span>
          </Box>
        </Flex>
      </StyledCardCart>
    </Fragment>
  );
}

CardCart.propTypes = {
  cartList: array,
  orderObj: shape({}),
  childHandler: func.isRequired,
};

CardCart.defaultProps = {
  cartList: [],
  orderObj: {},
};
export default CardCart;



// WEBPACK FOOTER //
// client/containers/GiftCardCart/cardCart.js